<template>
  <div class="tag-management">
    <div class="tag-management_content">
      <div class="tag-management_content-title">标签管理</div>
      <div class="tag-management_content-option">
        <a-button type="primary" class="tag-management_content-option-button" @click="creatTag()">新增</a-button>
        <a-input-search
          v-model="searchString"
          placeholder="请输入分组名称"
          style="width: 260px"
          @search="queryList"
        />
      </div>
      <div class="tag-management_content-list">
        <a-spin :spinning="spinningTable">
          <a-table :columns="columns" :data-source="tags" :pagination=false rowKey="id">
            <template
              slot="id"
              slot-scope="text, record, index"
            >
              <span>{{ index+1 }}</span>
            </template>
            <template
              slot="createTime"
              slot-scope="text"
            >
              <span :title="timeString(text)">{{ timeString(text) }}</span>
            </template>
            <template
              slot="updateTime"
              slot-scope="text"
            >
              <span :title="timeString(text)">{{ timeString(text) }}</span>
            </template>
            <template
              slot="operation"
              slot-scope="text, record"
            >
              <a-button
                class="tag-management_content-list-button"
                type="link"
                @click="setTag(record)"
              >
                编辑
              </a-button>
            </template>
          </a-table>
          <div class="tag-management_content-list-pagination">
            <a-pagination 
              v-model="pagination.pageNo" 
              :total="pagination.total" 
              show-size-changer
              show-quick-jumper
              @change="change"
              @showSizeChange="showSizeChange"
              :show-total="total => `共 ${pagination.total} 条`"
            />
          </div>
        </a-spin>
      </div>
    </div>
    <a-modal 
      v-model="tagData.visible" 
      :title="tagData.title" 
      :confirm-loading="tagData.confirmLoading"
      @ok="handleOk"
      @cancel="cancel">
      <a-spin :spinning="tagData.confirmLoading">
        <a-form-model
          ref="form"
          :model="formState"
          :rules="formRules"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
        >
          <a-form-model-item
            label="所属分组"
            prop="groupName"
          >
            <a-input v-model="formState.groupName" placeholder="请输入所属分组"/>
          </a-form-model-item>
          <a-form-model-item
            label="名称"
            prop="tagName"
          >
            <a-input v-model="formState.tagName" placeholder="请输入标签名字"/>
          </a-form-model-item>
          <a-form-model-item
            label="描述"
            prop="description"
          >
            <a-textarea
              v-model="formState.description"
              placeholder="请输入标签描述"
              :auto-size="{ minRows: 3, maxRows: 5 }"
              :maxlength="100"
            />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
// import { tags } from './adminData'
import { getAdminTags, creatAdminTag, setAdminTag } from '@/utils/api.js'
import { formatTime } from '@/utils'

export default {
  data() {
    return {
      isCreatTag: false,
      spinningTable: false,
      tags: [],
      formState: {
        groupName: '',
        tagName: '',
        description: ''
      },
      formRules: {
        groupName: [{ required: true, message: '请输入所属分组' }],
        tagName: [{ required: true, message: '请输入名称', trigger: 'change' }],
        description: [{ required: true, message: '请输入描述', trigger: 'change' }]
      },
      tagData: {
        confirmLoading: false,
        visible: false,
        title: ''
      },
      pagination: {
        limit: 10,
        pageNo: 1,
        total: 0
      },
      searchString: '',
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' },
          width: '140px',
        },
        {
          title: '所属分组',
          dataIndex: 'groupName',
          key: 'groupName',
          // width: '100px',
          ellipsis: true
        },
        {
          title: '名称',
          dataIndex: 'tagName',
          key: 'tagName',
          // width: '110px',
          ellipsis: true,
          scopedSlots: { customRender: 'tagName' },
        },
        {
          title: '引用次数',
          dataIndex: 'refCount',
          key: 'refCount',
          // width: '100px',
          ellipsis: true
        },
        {
          title: '描述',
          dataIndex: 'description',
          key: 'description',
          // width: '300px',
          ellipsis: true,
          scopedSlots: { customRender: 'description' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          ellipsis: true,
          scopedSlots: { customRender: 'updateTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'right',
          width: '100px'
        }
      ]
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.spinningTable = true
      const params = {
        groupName: this.searchString,
        limit: this.pagination.limit,
        pageNo: this.pagination.pageNo
      }
      getAdminTags(params).then(res => {
        this.spinningTable = false
        if (res.code === 0) {
          this.tags = res.data.records
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取标签列表失败')
        }
      })
    },
    creatTag() {
      this.tagData.title = '新增标签'
      Object.assign(this.formState,{
        groupName: '',
        tagName: '',
        description: ''
      })
      this.isCreatTag = true
      this.tagData.visible = true
    },
    setTag(data) {
      this.tagData.title = '编辑标签'
      Object.assign(this.formState,data)
      this.isCreatTag = false
      this.tagData.visible = true
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tagData.confirmLoading = true
          const fn = this.isCreatTag ? creatAdminTag : setAdminTag
          const params = {
            id: this.formState.id ? this.formState.id : '',
            groupName: this.formState.groupName,
            tagName: this.formState.tagName,
            description: this.formState.description
          }
          fn(params).then(res => {
            this.tagData.confirmLoading = false
            if (res.code === 0) {
              this.tagData.visible = false
              this.$message.success('操作成功')
              this.queryList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    cancel() {
      this.tagData.confirmLoading = false
      this.tagData.visible = false
      this.$refs.form.resetFields()
    },
    change() {
      this.queryList()
    },
    showSizeChange(current, size) {
      this.pagination.pageNo = 1
      this.pagination.limit = size
      this.queryList()
    },
    timeString(time) {
      return formatTime(time)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 5px;
}
.tag-management {
  height: 100%;
  background: #f7f7f8;
  padding: 10px 10px 0 10px;
  overflow: hidden;
  display: flex;
  &_content {
    flex: 1;
    background: #ffffff;
    border: 1px solid rgba(229,230,233,1);
    display: flex;
    flex-direction: column;
    &-title {
      flex: 0;
      padding: 12px 20px;
      font-size: 16px;
      color: #040C2C;
      letter-spacing: 0;
      line-height: 24px;
      font-weight: 400;
      border-bottom : 1px solid rgba(229,230,233,1);
    }
    &-option {
      flex: 0;
      margin-top: 20px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      &-button {
        padding: 0 10px;
      }
    }
    &-list {
      flex: 1;
      padding: 15px 20px;
      overflow-y: auto;
      &-button {
        padding: 0px;
      }
      &-article {
        cursor: pointer;
        font-size: 12px;
        color: #1740DC;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
      }
      &-pagination {
        display: flex;
        justify-content: flex-end;
        // padding: 0 20px 20px 0;
        padding: 10px 0;
      }
    }
  }
}
</style>